/** localStorage: user chose "Ne plus afficher" for the Medident extension CTA. */
export const MEDIDENT_EXTENSION_DISMISS_KEY = 'medidentExtensionInstallDismissed';

/** Firefox add-on package — always production (never localhost). */
export const MEDIDENT_EXTENSION_XPI_URL =
  'https://app.qualiteemed.ai/extensions/qualiteemed.xpi';

export function isFirefoxBrowser() {
  return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
}

export function isMedidentExtensionInstallDismissed() {
  try {
    return localStorage.getItem(MEDIDENT_EXTENSION_DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissMedidentExtensionInstall() {
  try {
    localStorage.setItem(MEDIDENT_EXTENSION_DISMISS_KEY, '1');
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Detect the Medident Firefox content script on this page.
 * Uses data-odontogram-filler when present, otherwise pings extract-request
 * (current signed .xpi always answers even without #odontogram-data).
 */
export function detectMedidentExtension(timeoutMs = 500) {
  return new Promise((resolve) => {
    if (typeof document === 'undefined') {
      resolve(false);
      return;
    }

    if (document.documentElement.getAttribute('data-odontogram-filler')) {
      resolve(true);
      return;
    }

    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      window.removeEventListener('odontogram-filler:extract-result', onCustomEvent);
      window.removeEventListener('message', onMessage);
      clearTimeout(timer);
      resolve(ok);
    };

    const onCustomEvent = () => finish(true);
    const onMessage = (event) => {
      if (event?.data?.type === 'odontogram-filler:extract-result') {
        finish(true);
      }
    };

    const timer = setTimeout(() => finish(false), timeoutMs);
    window.addEventListener('odontogram-filler:extract-result', onCustomEvent);
    window.addEventListener('message', onMessage);
    window.dispatchEvent(new CustomEvent('odontogram-filler:extract-request'));
  });
}
